/**
 * Тип позиции меню, для которой задаётся дефолтная картинка.
 * Значения приходят от geco.pos и совпадают с его контрактом api/front/default-images.
 */
export enum DefaultImagePositionTypeEnum {
  Group = 2,
  Product = 4,
  Size = 8,
}

/** Текущая дефолтная картинка для одного типа позиций. */
export interface DefaultImage {
  positionType: DefaultImagePositionTypeEnum;
  imageUrl: string;
  /** true - картинка клиента, false - наша стандартная. */
  isCustom: boolean;
}

/** Тело запроса на замену стандартной картинки своей. */
export interface DefaultImageRequestDto {
  imageUrl: string;
}
